module.exports = __webpack_public_path__ + "static/img/driblab_normal_color.0daeec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_normal_color.png
// module id = l6k4
// module chunks = 79